import script from "./ShopGuide.vue?vue&type=script&lang=ts&setup=true"
export * from "./ShopGuide.vue?vue&type=script&lang=ts&setup=true"

import "./ShopGuide.vue?vue&type=style&index=0&id=fbe121d8&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fbe121d8"]])

export default __exports__